import * as types from "../actions/actionTypes";
import {
  assign,
  cloneDeep,
  find,
  map,
  groupBy,
  size,
  findIndex,
  each,
  indexOf
} from "lodash";
import moment from "moment";

const initialState = {
  autoSuggestedList: [],
  vendorsListFromSearch: [],
  notifications: [],
  markedNotifications: [],
  toastMessage: "",
  toastType: "",
  jobCount: {},
  jobChatRooms: {},
  chatMessages: {},
  chatRooms: [],
  unreadMessages: [],
  emergencyList: [],
  profileImageUploaded: false,
  overviewData: {},
  currentWeek_openJobs: {},
  previousWeek_openJobs: {},
  ppreviousWeek_openJobs: {},
  previousWeek_avgResponseTime: null,
  currentWeek_avgResponseTime: null,
  getAllServices: []
};
export default function commonReducer(state = initialState, action) {
  console.log('What is the action ', action.type);
  switch (action.type) {
    case types.GET_AUTO_SUGGESTED_LIST:
      return assign({}, state, {
        autoSuggestedList: action.autoSuggestedList,
        currentComponentKey: ""
      });
    case types.SEARCH_VENDORS: {
      return assign({}, state, {
        vendorsListFromSearch: action.vendorsListFromSearch,
        currentComponentKey: action.changeCurrentComponentKey
          ? action.newUrl
          : ""
      });
    }
    case types.GET_ALL_SERVICES: {
      return assign({}, state, {
        getAllServices: action.allServices
      });
    }
    case types.CLEAR_COMPONENT_KEY: {
      return assign({}, state, { currentComponentKey: "" });
    }
    case types.PROFILE_IMAGE_UPDATED: {
      console.log("actions = ", action);
      return assign({}, state, {
        profileImageUploaded: action.profileImageUploaded
      });
    }
    case types.GET_NOTIFICATION_ALERTS: {
      if (action.unableToFetch) {
        return assign({}, state, {
          isNotificationsLoaded: true,
          unableToFetchNotifications: true
        });
      } else {
        const notifications = cloneDeep(state.notifications);
        // const newNotifications = filter(action.notifications, (notification) => { return !notification.isRead; });
        notifications.push(...action.notifications);
        return assign({}, state, {
          isNotificationsLoaded: true,
          unableToFetchNotifications: false,
          notifications: notifications,
          notificationsPageInfo: action.notificationsPageInfo,
          loadedMoreNotifications: action.isLoadMore,
          totalUnreadAlerts: action.totalUnreadAlerts
        });
      }
    }
    case types.CONFIRM_PAYMENT:
    {

      return assign({}, state, {
        paymentConfirmed: true,
      });


    }
    case types.MARK_NOTIFICATION_AS_READ: {
      const markedNotifications = cloneDeep(state.markedNotifications);
      const notifications = cloneDeep(state.notifications);
      let totalUnreadAlerts = cloneDeep(state.totalUnreadAlerts);
      const readNotificationIndex = findIndex(notifications, {
        alertId: action.alertID
      });
      console.log("alertId = ", action.alertID, readNotificationIndex, notifications);
      if (
        notifications[readNotificationIndex] &&
        !notifications[readNotificationIndex].isRead
      ) {
        notifications[readNotificationIndex].isRead = true;
        if (totalUnreadAlerts) {
          totalUnreadAlerts = totalUnreadAlerts - 1;
        }
      }
      markedNotifications.push(action.alertID);
      return assign({}, state, {
        markedNotifications: markedNotifications,
        totalUnreadAlerts: totalUnreadAlerts,
        notifications: notifications
      });
    }
    case types.NOTIFICATION_FROM_SOCKET: {
      const notifications = cloneDeep(state.notifications);
      const notification = action.notification;
      if (action.notificationType && notification) {
        notification["type"] = action.notificationType;
        notifications.unshift(notification);
        console.log("all notifications = ", notifications);
        return assign({}, state, {
          notifications: notifications
        });
      } else {
        return state;
      }
    }
    case types.UPDATE_NEW_COUNT: {
      let jobCount = cloneDeep(state.jobCount);
      if (jobCount && jobCount.waitingNewJob) {
        jobCount.waitingNewJob = jobCount.waitingNewJob
          ? jobCount.waitingNewJob - 1
          : 0;
        return assign({}, state, { jobCount: jobCount });
      } else {
        return state;
      }
    }
    case types.SHOW_TOAST_MESSAGE: {
      return assign({}, state, {
        toastMessage: action.toastMessage,
        toastType: action.toastType,
        hideButtonLoader: true
      });
    }
    case types.HIDE_TOAST_MESSAGE: {
      return assign({}, state, { toastMessage: "", toastType: "" });
    }
    case types.GET_TOP_LOCATIONS: {
      return assign({}, state, {
        topLocations: action.unableToFetch ? [] : action.topLocations,
        isTopLocationLoaded: true
      });
    }
    case types.GET_TOP_SERVICES: {
      return assign({}, state, {
        topServices: action.unableToFetch ? [] : action.topServices,
        isTopServicesLoaded: true
      });
    }
    case types.GET_JOB_FOR_TODAY: {
      return assign({}, state, {
        jobForToday: action.unableToFetch ? 0 : action.jobForToday,
        isJobForTodayLoaded: true
      });
    }
    case types.GET_JOB_DISTRIBUTION_CHART: {
      return assign({}, state, {
        jobDistributionChart: action.unableToFetch
          ? []
          : action.jobDistributionChart,
        isJobDistributionLoaded: true
      });
    }
    case types.GET_JOB_COUNT: {
      return assign({}, state, {
        jobCount: action.unableToFetch ? {} : action.jobCount,
        autoacceptjob: action.unableToFetch ? action.autoacceptjob : false,
        jobCountLoaded: true
      });
    }
    case types.GET_OVERVIEW: {
      if (action.unableToFetch) {
        return assign({}, state, { overviewLoaded: true });
      } else {
        let overviewData = action.overviewData;
        let updatedWinLoss = filterWinLoss(overviewData.winloss);
        overviewData.winloss = updatedWinLoss;
        return assign({}, state, {
          overviewData: overviewData,
          overviewLoaded: true
        });
      }
    }
    case types.UPDATE_OVERVIEW_WINLOSS: {
      console.log("overviewData && winLossData = ", state.overviewData);
      let overviewData = cloneDeep(state.overviewData);
      let winLossData = cloneDeep(overviewData.winloss);
      let dayIndex = findIndex(winLossData, data => {
        let existingDate = data && data.date && new Date(data.date).getDate();
        let incomingDate =
          action.incomingJob &&
            action.incomingJob.time &&
            new Date(action.incomingJob.time).getDate()
            ? new Date(action.incomingJob.time).getDate()
            : new Date().getDate();
        return existingDate == incomingDate;
      });
      if (dayIndex != -1 && winLossData.length == 7) {
        if (action.jobType == "waiting" && winLossData && winLossData.length) {
          winLossData[dayIndex].loss = winLossData[dayIndex].loss + 1;
        } else if (
          action.jobType == "confirmed" &&
          winLossData &&
          winLossData.length
        ) {
          winLossData[dayIndex].win = winLossData[dayIndex].win + 1;
        }
      } else {
        if (winLossData && winLossData.length == 7) {
          winLossData.shift();
        }
        if (action.jobType == "waiting") {
          winLossData &&
            winLossData.push({
              date: action.incomingJob.time
                ? action.incomingJob.time
                : new Date(),
              loss: 1,
              name: "Day" + winLossData.length,
              win: 0
            });
        } else if (action.jobType == "confirmed") {
          winLossData &&
            winLossData.push({
              date: action.incomingJob.time
                ? action.incomingJob.time
                : new Date(),
              loss: 0,
              name: "Day" + winLossData.length,
              win: 1
            });
        }
        map(winLossData, (value, key) => {
          if (!value) {
            winLossData[key] = { win: 0, loss: 0, name: "Day " + (key + 1) };
          } else if (winLossData.length && winLossData[key]) {
            winLossData[key].name = "Day" + (key + 1);
          }
        });
      }
      overviewData.winloss = winLossData;
      return assign({}, state, {
        overviewData: overviewData,
        overviewLoaded: true
      });
    }
    case types.UPDATE_JOB_FOR_THE_DAY: {
      let overviewData = cloneDeep(state.overviewData);
      if (
        overviewData.jobfortheday &&
        overviewData.jobfortheday.jobcount > -1
      ) {
        overviewData.jobfortheday.jobcount = action.jobCount;
      }
      return assign({}, state, {
        overviewData: overviewData,
        overviewLoaded: true
      });
    }
    case types.UPDATE_OVERVIEW_GRAPHS: {
      const overviewData = cloneDeep(state.overviewData);
      if ((action.notificationType === "New Request" || action.notificationType === "Auto Quote")) {
        if (
          overviewData.activities &&
          overviewData.activities.newRequest > -1
        ) {
          overviewData.activities.newRequest += 1;
        }
      } else if (action.notificationType === "Job Accepted") {
        if (
          overviewData.activities &&
          overviewData.activities.newRequest > -1
        ) {
          overviewData.activities.newJobs += 1;
        }
        if (
          overviewData.jobfortheday &&
          overviewData.jobfortheday.jobcount > -1
        ) {
          overviewData.jobfortheday.jobcount += 1;
        }
      } else if (action.notificationType === "job-message") {
        if (
          overviewData.activities &&
          overviewData.activities.newMessages > -1
        ) {
          overviewData.activities.newMessages += 1;
        }
      }
      return assign({}, state, { overviewData: overviewData });
    }
    case types.CREATE_CHAT_ROOM: {
      const authData = localStorage.businessAuthData
        ? JSON.parse(localStorage.businessAuthData)
        : "";
      const vendorId = authData ? authData.id : "";
      let customerProfilePhoto = "";
      let jobChatRooms = cloneDeep(state.jobChatRooms);
      if (vendorId) {
        each(action.messages, message => {
          if (message && message.userId != vendorId) {
            customerProfilePhoto = message.profilePhoto;
            return false;
          }
        });
      }
      jobChatRooms[action.jobrequestId + "|" + action.customerId] = {
        id: action.jobChatRoomId,
        jobrequestId: action.jobrequestId,
        customerId: action.customerId
      };
      let chatMessages = cloneDeep(state.chatMessages);
      chatMessages[action.jobChatRoomId] = {
        messages: action.messages,
        isFetched: true,
        customerProfilePhoto: customerProfilePhoto,
        vendorProfilePhoto: action.vendorProfilePhoto
      };
      return assign({}, state, {
        jobChatRooms: jobChatRooms,
        chatMessages: chatMessages
      });
    }
    case types.JOIN_CHAT_ROOM: {
      return assign({}, state, {
        currentJobChatRoomId: action.currentJobChatRoomId
      });
    }
    case types.SENT_NEW_MESSAGE: {
      let chatMessages = cloneDeep(state.chatMessages);
      if (
        chatMessages[action.jobChatRoomId] &&
        chatMessages[action.jobChatRoomId].messages
      ) {
        chatMessages[action.jobChatRoomId].messages.push({
          msg: action.message,
          userId: Number(localStorage.businessUserId),
          isFetched: true,
          jobChatRoomId: action.jobChatRoomId,
          createdAt: moment.utc(new Date()).format()
        });
      } else {
        chatMessages[action.jobChatRoomId] = {
          isFetched: true,
          userId: Number(localStorage.businessUserId),
          messages: [{ msg: action.message }],
          jobChatRoomId: action.jobChatRoomId,
          createdAt: moment.utc(new Date()).format()
        };
      }
      return assign({}, state, { chatMessages: chatMessages });
    }
    case types.RECEIVE_NEW_MESSAGE: {
      action.message.jobChatRoomId = action.message.job_chatroom_id;
      action.message.userId = action.message.user_id;
      action.message.createdAt = action.message.created_at;
      const authData = JSON.parse(localStorage.businessAuthData);
      let chatRooms = cloneDeep(state.chatRooms);
      let chatMessages = cloneDeep(state.chatMessages);
      let unreadMessages = cloneDeep(state.unreadMessages);
      const chatRoom = chatMessages[action.jobChatRoomId]
        ? cloneDeep(chatMessages[action.jobChatRoomId])
        : "";
      const customerProfilePhoto = action.user ? action.user.profilePhoto : "";
      if (chatRoom && chatRoom.customerProfilePhoto) {
        action.message.profilePhoto = chatRoom.customerProfilePhoto;
      } else if (chatRoom) {
        chatRoom.customerProfilePhoto = customerProfilePhoto;
        action.message.profilePhoto = customerProfilePhoto;
      }
      if (
        chatMessages[action.jobChatRoomId] &&
        chatMessages[action.jobChatRoomId].messages
      ) {
        const messageExist = find(
          chatMessages[action.jobChatRoomId].messages,
          function (message) {
            return message.id === action.message.id;
          }
        );
        if (!messageExist) {
          chatMessages[action.jobChatRoomId].messages.push(action.message);
        }
      } else {
        chatMessages[action.jobChatRoomId] = action.message;
      }
      let garage = {};
      if (authData) {
        garage = {
          companyprofilename: "",
          email: authData.email,
          id: authData.garageId,
          phone: authData.phone,
          profilePhoto: chatRoom ? chatRoom.vendorProfilePhoto : "",
          userId: authData.id
        };
      }
      //For updating data on message dropdown
      let currentMessageIndex = undefined;
      const currentMessage = find(unreadMessages, function (
        unreadMessage,
        index
      ) {
        const jobChatRoomId =
          unreadMessage && unreadMessage.lastMessage
            ? unreadMessage.lastMessage.jobChatroomId ||
            unreadMessage.lastMessage.jobChatRoomId
            : "";
        if (jobChatRoomId == action.jobChatRoomId) {
          currentMessageIndex = index;
          return unreadMessage;
        }
      });
      if (currentMessage && currentMessageIndex > -1) {
        currentMessage.lastMessage = action.message;
        unreadMessages.splice(currentMessageIndex, 1);
        unreadMessages.unshift(currentMessage);
      } else {
        unreadMessages.unshift({
          count: 1,
          lastMessage: action.message,
          user: action.user,
          userbookingrequest: action.userbookingrequest
        });
      }
      //For updating data on inbox view
      let existingChatRoomIndex = undefined;
      const existingChatRoom = find(chatRooms, function (chatRoom, index) {
        if (chatRoom && chatRoom.id == action.jobChatRoomId) {
          existingChatRoomIndex = index;
          return chatRoom;
        }
      });
      if (existingChatRoom && existingChatRoomIndex > -1) {
        if (existingChatRoom.messages && existingChatRoom.messages.length) {
          existingChatRoom.messages.push(action.message);
        }
        chatRooms.splice(existingChatRoomIndex, 1);
        chatRooms.unshift(existingChatRoom);
      } else {
        chatRooms.unshift({
          customer: action.user,
          customerId: action.user ? action.user.id : "",
          garage: garage,
          garageId: authData && authData.garageId ? authData.garageId : "",
          id: action.message.jobChatRoomId,
          jobrequestId: action.userbookingrequest.id,
          messages: [action.message],
          unseenMsg: 1,
          userbookingrequest: action.userbookingrequest
        });
      }
      return assign({}, state, {
        chatMessages: chatMessages,
        chatRooms: chatRooms,
        unreadMessages: unreadMessages
      });
    }
    case types.GET_ALL_CHATROOMS: {
      if (action.unableToFetch) {
        return assign({}, state, { isChatRoomsLoaded: true });
      } else {
        return assign({}, state, {
          isChatRoomsLoaded: true,
          chatRooms: action.chatRooms
        });
      }
    }
    case types.GET_ALL_MESSAGE_OF_CHAT_ROOM: {
      if (action.unableToFetch) {
        let chatMessages = cloneDeep(state.chatMessages);
        chatMessages[action.jobrequestId + "|" + action.customerId] = {
          isFetched: true,
          messages: []
        };
        return assign({}, state, { chatMessages: chatMessages });
      } else {
        let chatMessages = cloneDeep(state.chatMessages);
        chatMessages[action.jobrequestId + "|" + action.customerId] = {
          isFetched: true,
          messages: action.messages
        };
        return assign({}, state, { chatMessages: chatMessages });
      }
    }
    case types.GET_ALL_UNREAD_MESSAGES: {
      if (action.unableToFetch) {
        return assign({}, state, {
          isMessagesLoaded: true,
          unableToFetchUnreadMessages: true
        });
      } else {
        return assign({}, state, {
          isMessagesLoaded: true,
          unreadMessages: action.unreadMessages,
          unableToFetchUnreadMessages: false
        });
      }
    }
    case types.GET_OPEN_JOBS_DATA: {
      let currentWeek_openJobs = cloneDeep(state.currentWeek_openJobs);
      let previousWeek_openJobs = cloneDeep(state.previousWeek_openJobs);
      let ppreviousWeek_openJobs = cloneDeep(state.ppreviousWeek_openJobs);
      let currentWeek_jobAccepted = [],
        currentWeek_newJobQuotes = [],
        currentWeek_newRequest = [],
        currentWeek_inProgress = [],
        currentWeek_declined = [],
        currentWeek_expired = [],
        previousWeek_jobAccepted = [],
        previousWeek_newJobQuotes = [],
        previousWeek_newRequest = [],
        previousWeek_inProgress = [],
        previousWeek_declined = [],
        previousWeek_expired = [],
        ppreviousWeek_jobAccepted = [],
        ppreviousWeek_newJobQuotes = [],
        ppreviousWeek_newRequest = [],
        ppreviousWeek_inProgress = [],
        ppreviousWeek_declined = [],
        ppreviousWeek_expired = [],
        currentWeek_avgResponseTime,
        previousWeek_avgResponseTime;
      if (action.getOpenJobsData && action.getOpenJobsData.data) {
        map(action.getOpenJobsData && action.getOpenJobsData.data, data => {
          if (data.type == "New Request") {
            currentWeek_newRequest.push(data);
          } else if (data.type == "Job Accepted") {
            currentWeek_jobAccepted.push(data);
          } else if (data.type == "In Progress Jobs") {
            currentWeek_inProgress.push(data);
          } else if (data.type == "Declined Jobs") {
            currentWeek_declined.push(data);
          } else if (data.type == "Expired Jobs") {
            currentWeek_expired.push(data);
          } else if (data.type == "New Job Quotes") {
            currentWeek_newJobQuotes.push(data);
          } else if (data.avgResponseTime > -1) {
            currentWeek_avgResponseTime = data;
          }
        });
        currentWeek_openJobs["newRequest"] = currentWeek_newRequest;
        currentWeek_openJobs["jobAccepted"] = currentWeek_jobAccepted;
        currentWeek_openJobs["newJobQuotes"] = currentWeek_newJobQuotes;
        currentWeek_openJobs["inProgress"] = currentWeek_inProgress;
        currentWeek_openJobs["declined"] = currentWeek_declined;
        currentWeek_openJobs["expired"] = currentWeek_expired;
      }
      if (action.getOpenJobsData && action.getOpenJobsData.previous) {
        map(action.getOpenJobsData && action.getOpenJobsData.previous, data => {
          if (data.type == "New Request") {
            previousWeek_newRequest.push(data);
          } else if (data.type == "Job Accepted") {
            previousWeek_jobAccepted.push(data);
          } else if (data.type == "In Progress Jobs") {
            previousWeek_inProgress.push(data);
          } else if (data.type == "Declined Jobs") {
            previousWeek_declined.push(data);
          } else if (data.type == "Expired Jobs") {
            previousWeek_expired.push(data);
          } else if (data.type == "New Job Quotes") {
            previousWeek_newJobQuotes.push(data);
          } else if (data.avgResponseTime > -1) {
            previousWeek_avgResponseTime = data;
          }
        });
        previousWeek_openJobs["newRequest"] = previousWeek_newRequest;
        previousWeek_openJobs["jobAccepted"] = previousWeek_jobAccepted;
        previousWeek_openJobs["newJobQuotes"] = previousWeek_newJobQuotes;
        previousWeek_openJobs["inProgress"] = previousWeek_inProgress;
        previousWeek_openJobs["declined"] = previousWeek_declined;
        previousWeek_openJobs["expired"] = previousWeek_expired;
      }
      if (action.getOpenJobsData && action.getOpenJobsData.pprevious) {
        map(
          action.getOpenJobsData && action.getOpenJobsData.pprevious,
          data => {
            if (data.type == "New Request") {
              ppreviousWeek_newRequest.push(data);
            } else if (data.type == "Job Accepted") {
              ppreviousWeek_jobAccepted.push(data);
            } else if (data.type == "In Progress Jobs") {
              ppreviousWeek_inProgress.push(data);
            } else if (data.type == "Declined Jobs") {
              ppreviousWeek_declined.push(data);
            } else if (data.type == "Expired Jobs") {
              ppreviousWeek_expired.push(data);
            } else if (data.type == "New Job Quotes") {
              ppreviousWeek_newJobQuotes.push(data);
            }
          }
        );
        ppreviousWeek_openJobs["newRequest"] = ppreviousWeek_newRequest;
        ppreviousWeek_openJobs["jobAccepted"] = ppreviousWeek_jobAccepted;
        ppreviousWeek_openJobs["newJobQuotes"] = ppreviousWeek_newJobQuotes;
        ppreviousWeek_openJobs["inProgress"] = ppreviousWeek_inProgress;
        ppreviousWeek_openJobs["declined"] = ppreviousWeek_declined;
        ppreviousWeek_openJobs["expired"] = ppreviousWeek_expired;
      }
      return assign({}, state, {
        currentWeek_openJobs: currentWeek_openJobs,
        previousWeek_openJobs: previousWeek_openJobs,
        ppreviousWeek_openJobs: ppreviousWeek_openJobs,
        currentWeek_avgResponseTime: currentWeek_avgResponseTime,
        previousWeek_avgResponseTime: previousWeek_avgResponseTime
      });
    }

    case types.INCREASE_OPEN_JOBS: {
      let currentWeek_openJobs = cloneDeep(state.currentWeek_openJobs);
      console.log("currentWeek openJobs = ", currentWeek_openJobs);
      if (action.jobType == "newrequest") {
        map(currentWeek_openJobs && currentWeek_openJobs.newRequest, data => {
          let stateDate = data && data.date && moment(data.date).date();
          let actionDate =
            action.data && action.data.time && moment(action.data.time).date();
          if (stateDate == actionDate) {
            data.count = data.count + 1;
          }
        });
      } else if (action.jobType == "jobAccepted") {
        map(currentWeek_openJobs && currentWeek_openJobs.jobAccepted, data => {
          let stateDate = data && data.date && moment(data.date).date();
          let actionDate = moment().date();
          if (stateDate == actionDate) {
            data.count = data.count + 1;
          }
        });
      }
      return {
        ...state,
        currentWeek_openJobs: currentWeek_openJobs
      };
    }

    case types.CHANGE_STATUS_OF_SIDEBAR_COUNT: {
      let jobCount = cloneDeep(state.jobCount);
      if (action.fromNotification) {
        if (action.notificationType === "New Request") {
          jobCount.waiting = jobCount.waiting + 1;
          jobCount.waitingNewJob = jobCount.waitingNewJob + 1;
        } else if (action.notificationType === "Job Accepted") {
          jobCount.applied = jobCount.applied ? jobCount.applied - 1 : 0;
          jobCount.confirmed = jobCount.confirmed + 1;
        } else if (action.notificationType === "Applied Job") {
          jobCount.applied = jobCount.applied + 1;
        } else if (
          action.notificationType === "Request Cancel" ||
          action.nofificationType === "Confirmed Job Decline") {
          if (
            action.notification &&
            action.notification.previousStatusId == 2
          ) {
            jobCount.waiting = jobCount.waiting ? jobCount.waiting - 1 : 0;
            jobCount.waitingNewJob = jobCount.waiting
              ? jobCount.waitingNewJob
              : 0;
          } else if (
            action.notification &&
            action.notification.previousStatusId == 1
          ) {
            jobCount.applied = jobCount.applied ? jobCount.applied - 1 : 0;
          } else if (
            action.notification &&
            action.notification.previousStatusId == 3
          ) {
            jobCount.inprogress = jobCount.inprogress
              ? jobCount.inprogress - 1
              : 0;
          } else if (
            action.notification &&
            action.notification.previousStatusId == 4
          ) {
            jobCount.confirmed = jobCount.confirmed
              ? jobCount.confirmed - 1
              : 0;
          }
        }
      } else {
        if (action.changeJobStatusTo == "decline") {
          if (action.currentJobStatus == "waiting") {
            jobCount.waiting = jobCount.waiting ? jobCount.waiting - 1 : 0;
          } else if (action.currentJobStatus == "applied") {
            jobCount.applied = jobCount.applied ? jobCount.applied - 1 : 0;
          } else if (action.currentJobStatus == "confirmed") {
            jobCount.confirmed = jobCount.confirmed
              ? jobCount.confirmed - 1
              : 0;
          }
        } else if (action.changeJobStatusTo == "applied") {
          jobCount.waiting = jobCount.waiting ? jobCount.waiting - 1 : 0;
          jobCount.applied = jobCount.applied + 1;
        } else if (action.changeJobStatusTo == "In Progress") {
          jobCount.confirmed = jobCount.confirmed ? jobCount.confirmed - 1 : 0;
          jobCount.inprogress = jobCount.inprogress + 1;
        } else if (action.changeJobStatusTo == "Completed") {
          if (action.currentJobStatus === "confirmed") {
            jobCount.confirmed = jobCount.confirmed
              ? jobCount.confirmed - 1
              : 0;
          } else {
            jobCount.inprogress = jobCount.inprogress
              ? jobCount.inprogress - 1
              : 0;
          }
        }
      }
      return assign({}, state, { jobCount: jobCount });
    }
    case types.EMERGENCY_LIST: {
      let allNotifications = [];
      console.log("Reducer EMG list = ", action.emergencyList);
      if (action.emergencyList && action.emergencyList.length) {
        allNotifications = action.emergencyList.filter((eachNotifications) => {
          return eachNotifications && eachNotifications.bookingId.includes('EMG');
        })
      }
      return assign({}, state, {
        emergencyList: allNotifications
      });
    }
    case types.MARK_MESSAGES_AS_READ: {
      let chatMessages = cloneDeep(state.chatMessages);
      let chatRooms = cloneDeep(state.chatRooms);
      let unreadMessageIds = cloneDeep(state.unreadMessageIds);
      let unreadMessages = cloneDeep(state.unreadMessages);
      each(action.unSeenMessageIds, message => {
        const unreadMessageIndex = indexOf(state.unreadMessageIds, message);
        if (unreadMessageIndex > -1) {
          unreadMessageIds.splice(unreadMessageIndex, 1);
        }
      });
      const chatRoomIndex = findIndex(chatRooms, function (chatRoom) {
        return chatRoom.id == action.chatRoomData.id;
      });
      if (chatRoomIndex > -1) {
        chatRooms[chatRoomIndex].unseenMsg = 0;
      }
      let readMessageIndex = undefined;
      each(unreadMessages, (message, idx) => {
        if (
          message.lastMessage &&
          message.lastMessage.id &&
          action.unSeenMessageIds.indexOf(message.lastMessage.id) > -1
        ) {
          readMessageIndex = idx;
        }
      });
      chatMessages[action.chatRoomData.id] = action.currentChat;
      if (readMessageIndex > -1) {
        unreadMessages.splice(readMessageIndex, 1);
      }
      return assign({}, state, {
        chatMessages: chatMessages,
        chatRooms: chatRooms,
        unreadMessageIds: unreadMessageIds,
        unreadMessages: unreadMessages
      });
    }
    case types.MARK_MESSAGES_AS_READ_FROM_DROPDOWN: {
      let unreadMessages = cloneDeep(state.unreadMessages);
      let readMessageIndex = undefined;
      each(unreadMessages, (message, idx) => {
        if (
          message.lastMessage &&
          action.jobChatRoomId == message.lastMessage.jobChatRoomId
        ) {
          readMessageIndex = idx;
        }
      });
      if (readMessageIndex > -1) {
        unreadMessages.splice(readMessageIndex, 1);
      }
      return assign({}, state, { unreadMessages: unreadMessages });
    }
    case types.GET_VENDOR_TAX:
      return (assign({}, state, {
        taxInfo: action.taxInfo
      }));
    case types.GET_JOB_SCHEDULE: {
      let splitedJobSchedule = splitJobSchedule(action.jobSchedule);
      if (action.unableToFetch) {
        return assign({}, state, {
          jobScheduleLoaded: true,
          jobScheduleCount: 0
        });
      } else {
        return assign({}, state, {
          jobScheduleLoaded: true,
          jobSchedule: splitedJobSchedule,
          jobScheduleCount:
            action.jobSchedule && action.jobSchedule.length
              ? action.jobSchedule.length
              : 0
        });
      }
    }
    case types.TOGGLE_MESSAGE_TAB: {
      return assign({}, state, { showMessageTab: action.show });
    }
    case types.APPLY_PROMOTIONAL_OFFERS: {
      console.log('🔥 🔥 Hitting the data of Promotion ', action.promotionalOffersData);
      return assign({}, state, {
        promotionalOffersMessage: action.promotionalOffersMessage,
        promotionalOffersIsApproved: action.promotionalOffersIsApproved,
        discountAmount: action.discountAmount,
      });
    }
    default:
      return state;
  }
}

function splitJobSchedule(jobSchedule) {
  let todayJobs = [];
  let tommorowJobs = [];
  let totalJobs = [];
  map(jobSchedule, job => {
    let jobDate =
      job &&
      new Date(job.jobStartDatetime) &&
      new Date(job.jobStartDatetime).getDate();
    let todayDate = new Date() && new Date().getDate();
    if (jobDate == todayDate) {
      todayJobs.push(job);
    } else if (jobDate == todayDate + 1) {
      tommorowJobs.push(job);
    }
  });
  todayJobs.length && totalJobs.push({ title: "TODAY", jobs: todayJobs });
  tommorowJobs.length &&
    totalJobs.push({ title: "TOMORROW", jobs: tommorowJobs });
  return totalJobs;
}

function filterWinLoss(winlossData) {
  let groupedWinLossData = groupBy(winlossData, "date");
  if (!groupedWinLossData || !size(groupedWinLossData)) {
    return [];
  }
  let arr = Array(7);
  // let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  map(groupedWinLossData, (value, key) => {
    let today = new Date();
    let yesterday = new Date(key);
    let timeDiff = today.getTime() - yesterday.getTime();
    let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    if (diffDays > 0 && diffDays <= 7) {
      // let winLoss = { win: 0, loss: 0, name: key ? months[new Date(key).getMonth()] + " " + new Date(key).getDate() : '', date: value };
      let winLoss = {
        win: 0,
        loss: 0,
        name: "Day " + diffDays,
        data: value,
        date: key
      };
      let acceptedRequest = find(value, { type: "Job Accepted" });
      let newRequest = find(value, { type: "Job Loss" });
      if (!acceptedRequest || !acceptedRequest.count) {
        winLoss.loss = newRequest && newRequest.count ? newRequest.count : 0;
        winLoss.win = 0;
      } else {
        winLoss.win = acceptedRequest.count;
        winLoss.loss = newRequest ? newRequest.count : 0;
      }
      arr[diffDays - 1] = winLoss;
    }
    return;
  });
  arr.reverse();
  map(arr, (value, key) => {
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let date = new Date();
    date.setDate(date.getDate() - (6 - key));
    if (!value) {
      arr[key] = { win: 0, loss: 0, name: `${date.getDate()} ${months[date.getMonth()]}`, date: date };
    } else if (arr.length && arr[key]) {
      arr[key].name = `${date.getDate()}' ${months[date.getMonth()]}`;
      arr[key].date = date;
    }
  });

  return arr;
}



// WEBPACK FOOTER //
// ./src/reducers/commonReducer.js